import { render } from "./PlanillaInspeccion.vue?vue&type=template&id=c898b788&scoped=true"
import script from "./PlanillaInspeccion.vue?vue&type=script&lang=js"
export * from "./PlanillaInspeccion.vue?vue&type=script&lang=js"

import "./PlanillaInspeccion.vue?vue&type=style&index=0&id=c898b788&scoped=true&lang=css"
import "./PlanillaInspeccion.vue?vue&type=style&index=1&id=c898b788&lang=scss&scoped=true"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c898b788"]])

export default __exports__